export enum KeyDriveButtonStyles {
    DefaultStyles
}

export type KeyDriveButtonType = "primary" | "secondary"